import React from "react";
import { useSelector } from "react-redux";

import { setShowForm, reset } from "../../redux/profile/settings/changePass/slice";
import { setShowWindow } from "../../redux/profile/authAndReg/slice";
import { useAppDispatch } from "../../redux/store";
import { changePassSelector } from "../../redux/profile/settings/changePass/selectors";

import { Modal, Button } from "../../components";
import { PhoneForm, MessageForm, SmsCodeForm, NewPasswordForm } from "./Forms";

import styles from "./PassChangeMockPage.module.scss";

import { ModalTexts } from "../../resources/locale";
import { FormNames, WindowNames } from "../../resources/constants";

import { PassChangePropsType } from "./types";
import { SmsRegCodeForm } from "./Forms/SmsReg/SmsReg";

export const PassChangeModal: React.FC<PassChangePropsType> = (props) => {
  const { isOpen, setIsOpen, title, subTitle } = props;

  const { showForm } = useSelector(changePassSelector);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (showForm === FormNames.PASSWORD_APPLY) {
      dispatch(reset());
      dispatch(setShowWindow(WindowNames.AUTH));
    }
  }, [showForm, dispatch]);

  const modalRenderController = (showForm: string) => {
    switch (showForm) {
      case FormNames.PHONE:
        return (
          <Modal
            title={title}
            subTitle={subTitle}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <PhoneForm handleSubmitForm={handleSetCodeForm} />
          </Modal>
        );
      case FormNames.MESSAGE:
        return (
          <Modal
            title={ModalTexts.changePass.confirmMessage.TITLE}
            subTitle={ModalTexts.changePass.confirmMessage.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <MessageForm />
          </Modal>
        );
      case FormNames.CODEREG:
        return (
          <Modal
            title={ModalTexts.changePass.confirmMessage.TITLE}
            subTitle={ModalTexts.changePass.confirmMessage.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <SmsRegCodeForm />
          </Modal>
        );
      case FormNames.CODE:
        return (
          <Modal
            title={ModalTexts.changePass.inputSmsCode.TITLE}
            subTitle={ModalTexts.changePass.inputSmsCode.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <SmsCodeForm handleSubmitForm={handleSetNewPassForm} />
          </Modal>
        );
      case FormNames.PASSWORD:
        return (
          <Modal
            title={ModalTexts.changePass.inputNewPassword.TITLE}
            subTitle={ModalTexts.changePass.inputNewPassword.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <NewPasswordForm handleSubmitForm={handleSetPassApplyForm} />
          </Modal>
        );
      case FormNames.PASSWORD_APPLY:
        return null;
      case FormNames.REGAPPLY:
        return (
          <Modal
            title={ModalTexts.changePass.passwordApply.TITLE}
            subTitle={ModalTexts.changePass.passwordApply.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          >
            <Button newStyles={styles.button} onClickFunc={handleEndChangePassProcess}>
              Ок
            </Button>
          </Modal>
        );
      default:
        return null;
    }
  };

  const handleSetPhoneForm = () => {
    dispatch(setShowForm(FormNames.PHONE));
  };

  const handleSetCodeForm = () => {
    dispatch(setShowForm(FormNames.CODE));
  };

  const handleSetNewPassForm = () => {
    dispatch(setShowForm(FormNames.PASSWORD));
  };

  const handleSetPassApplyForm = () => {
    dispatch(setShowForm(FormNames.PASSWORD_APPLY));
  };

  const handleEndChangePassProcess = () => {
    setIsOpen(false);
    dispatch(reset());
  };


  const currentModal = modalRenderController(showForm);

  return <>{currentModal}</>;
};
